import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { axiosBaseQuery } from './baseQuery';

const OPTION_VALUES_URL = `api/option-details-values`;

export const optionValueAPI = createApi({
  reducerPath: 'optionValue.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['optionValue'],
  endpoints: (builder) => ({
    getOptionValuesByOptionIds: builder.query({
      query: (queryParams) => ({
        url: `${OPTION_VALUES_URL}?${queryParams}`,
        method: 'GET',
      }),
      transformResponse: (response) => {
        return response;
      },
      providesTags: ['optionValue'],
      forceRefetch(params) {
        return true;
      },
    }),
  }),
});

export const { useLazyGetOptionValuesByOptionIdsQuery } = optionValueAPI;
